module.exports = __webpack_public_path__ + "static/media/DTUK-2025-LOGO.1a2931dc.png";